import json from './sprite.js';

export default {
    handle: 'ENG_SPT3-Window_225003111',
    label: 'en_SPT3-Window_225003111',
    json,
};
